/**
 * Created by tendlich on 03/03/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        BaseModel = require("models/BaseModel"),
        CP_CONST = require("connection-const"),
        ChatStateModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        ChatStateModel = BaseModel.extend({
            name: "ChatStateModel",
            IFRAME_STATES: CP_CONST.CONVERSATION_IFRAME_STATE,
            CHAT_TAB_STATES: CP_CONST.CHAT_TAB_STATES,

            initialize: function (options) {
                this._chatChannel = options;
                this._chatTabState = CP_CONST.CHAT_TAB_STATES.CONTACTS_LIST;
                this._bindEvents();
            },

            _bindEvents: function () {
                var cVent = this._chatChannel.vent;
                this._iframeState = this.IFRAME_STATES.NONE;
                this.listenTo(cVent, "cpChatUI:display:messagingFrame", function () {
                    this._iframeState = this.IFRAME_STATES.MESSAGING;
                }, this);
                this.listenTo(cVent, "cpChatUI:display:chatFrame", function () {
                    this._iframeState = this.IFRAME_STATES.CHAT;
                }, this);

                this.listenTo(cVent, "cpChatUI::layout:contacts:show", function () {
                    this._chatTabState = this.CHAT_TAB_STATES.CONTACTS_LIST;
                }, this);
                this.listenTo(cVent, "cpChatUI::layout:survey:show", function () {
                    this._chatTabState = this.CHAT_TAB_STATES.SURVEY_WINDOW;
                }, this);
                this.listenTo(cVent, "cpChatUI::layout:chat:show", function () {
                    this._chatTabState = this.CHAT_TAB_STATES.CHAT_WINDOW;
                }, this);
            },

            getState: function () {
                var obj = {
                    iframe: this._iframeState,
                    chatTab: this._chatTabState
                };
                return obj;
            }
        });
    });

    return ChatStateModel;
});
